import clienteAxios from "../config/axios";

export async function getDimensiones () {
    return clienteAxios.get(`/dimensiones`);
}

export async function getSubcuentas () {
    return clienteAxios.get(`/subcuentas`);
}

export async function getSubcuentasByDimension (codDim) {
    return clienteAxios.get(`/subcuentasByDimension/${codDim}`);
}

export async function uploadSubcuenta ( userID, userName) {
    return clienteAxios.post('/actualizar/subcuentas', {userID, userName});
}